import { ADMIN_ROUTES } from '~/constants/router'
import { lazyRetry } from '~/utils/lazyRetry'
import { adminRoles } from '~/modules/auth/conditions'

const BrandList = lazyRetry(() => import('~/pages/Brand/BrandList'))
const PantryBrandList = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.BrandPage })),
)

const BrandRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}/brands`,
    component: BrandList,
    pantryComponent: PantryBrandList,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    routeName: 'Brands List',
  },
]

export default BrandRouters
